module.exports = __webpack_public_path__ + "static/media/sonicscale-5.c6791ca6.jpg";